import {
  Create,
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  useTranslate,
} from 'react-admin';
import { Box, Typography, Grid } from '@mui/material';
import { PhoneInputWithCountry } from '../../components';

const ContactCreateToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

export const ContactCreate = () => {
  const translate = useTranslate();

  return (
    <Create>
      <SimpleForm toolbar={<ContactCreateToolbar />}>
        <Box mb={2}>
          <Typography variant="h6">{translate('resources.contact.create.title')}</Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextInput source="name" label={translate('resources.contact.fields.name')} fullWidth required />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <TextInput source="email" label={translate('resources.contact.fields.email')} type="email" fullWidth />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <PhoneInputWithCountry source="phoneNumber" label={translate('resources.contact.fields.phoneNumber')} fullWidth defaultCountry="BR" />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
